import React from 'react';
import { useTranslation } from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';
import { Typography } from '@mui/material';
import { CouchIcon, AnimatedCheckMark } from 'components/elements/Icons';

import Styles from './styles';

const useStyles = makeStyles(Styles);

function ThankYou() {
  const classes = useStyles();
  const { t } = useTranslation('labels');
  return (
    <div className={classes.thankYouPage}>
      <AnimatedCheckMark />
      <div className={classes.textContainer}>
        <h1 className={classes.title}>
          <br className={classes.mobileBreak} />
          {t('thank_you_your_request_has_been_submitted')}
        </h1>
        <Typography className={classes.subTitle} variant="body1" component="h2">
          {t('your_appointment_form_has_been_sent_to_our_intake_team')}
        </Typography>
      </div>
      <CouchIcon />
    </div>
  );
}

export default ThankYou;
